// extracted by mini-css-extract-plugin
module.exports = {"sigContainer":"SignatureBox_sigContainer__1S090","sigCanvas":"SignatureBox_sigCanvas__1ITxE","buttons":"SignatureBox_buttons__3sLSv","sigImage":"SignatureBox_sigImage__P99on"};